// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__blM16","notice":"Contact_notice__MYif-","note":"Contact_note__Tfbqn"};